class VipPopup extends HTMLElement {
  constructor() {
    super();
    this._onKeydown = this._onKeydown.bind(this);
    this._onAnnouncementClick = this._onAnnouncementClick.bind(this);
  }

  connectedCallback() {
    this.STORAGE_KEY = 'vipPopupShown';
    this.delay       = parseInt(this.getAttribute('data-delay'), 10) || 0;
    this.testMode    = this.getAttribute('data-test-mode') === 'true';

    this.stepForm    = this.querySelector('[data-vip-step="form"]');
    this.stepSuccess = this.querySelector('[data-vip-step="success"]');

    this.querySelectorAll('[data-vip-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', this._onKeydown);
    document.addEventListener('click', this._onAnnouncementClick);

    if (!this.hidden) {
      // Server already rendered popup as visible (post-submit success / errors).
      document.body.style.overflow = 'hidden';
      this._markShown();
      this._cleanContactPostedParam();
    } else if (this._shouldAutoShow()) {
      if (this.delay > 0) {
        setTimeout(() => this.open(), this.delay * 1000);
      } else {
        this.open();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeydown);
    document.removeEventListener('click', this._onAnnouncementClick);
  }

  open() {
    this.hidden = false;
    document.body.style.overflow = 'hidden';
    this._markShown();
  }

  close() {
    this.hidden = true;
    document.body.style.overflow = '';
  }

  reset() {
    this.classList.remove('vip-popup--success');
    if (this.stepForm) this.stepForm.hidden = false;
    if (this.stepSuccess) this.stepSuccess.hidden = true;
  }

  _markShown() {
    if (this.testMode) return;
    try { localStorage.setItem(this.STORAGE_KEY, '1'); } catch (e) {}
  }

  _cleanContactPostedParam() {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('contact_posted')) return;
      url.searchParams.delete('contact_posted');
      const cleaned = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
      window.history.replaceState({}, document.title, cleaned);
    } catch (e) {}
  }

  _shouldAutoShow() {
    if (this.testMode) return true;
    try {
      if (localStorage.getItem(this.STORAGE_KEY) === '1') return false;
    } catch (e) {}
    return true;
  }

  _onKeydown(e) {
    if (e.key === 'Escape' && !this.hidden) this.close();
  }

  _onAnnouncementClick(e) {
    const trigger = e.target && e.target.closest && e.target.closest('.announcement-bar__text, [data-vip-open]');
    if (!trigger) return;
    e.preventDefault();
    this.reset();
    this.open();
  }
}

if (!customElements.get('vip-popup')) {
  customElements.define('vip-popup', VipPopup);
}
